/**
 * Import a script that cannot be imported as a module due to for example CORS
 * Will prevent the same script being loaded multiple times, and handle a queue of callbacks whilst it is being loaded
 *
 * @param {string} src The URL of the script to load
 * @param {Function} [callback] Called once the script has loaded
 * @param {Object} [attr] Additional attributes to set on the script tag
 * @param {Function} [error] Called with an Error if the script could not be loaded
 */
const scripts = [];

export default (src, callback, attr = {}, error) => {
	let i = scripts.findIndex(item => item.src === src);

	// load the script
	if (i === -1) {

		// create script object
		const script = document.createElement("script");
		attr = Object.assign({
			src: src,
			async: true
		}, attr);
		Object.entries(attr).forEach(([key, item]) => script[key] = item);

		// setup load callback
		i = scripts.length;
		scripts.push({src, callbacks: callback ? [callback] : [], errors: error ? [error] : [], loaded: false, err: null});
		script.addEventListener("load", () => {
			scripts[i].callbacks.forEach(item => item());
			scripts[i].loaded = true;
		}, {once: true});

		// tell the callers, so they are not left waiting on a script that will never arrive
		script.addEventListener("error", () => {
			const err = new Error("Could not load " + src);
			scripts[i].errors.forEach(item => item(err));
			scripts[i].err = err;
		}, {once: true});

		// attach the script
		document.body.append(script);

	// the script already failed
	} else if (scripts[i].err) {
		if (error) {
			error(scripts[i].err);
		}

	// add callbacks to the queues
	} else if (!scripts[i].loaded) {
		if (callback) {
			scripts[i].callbacks.push(callback);
		}
		if (error) {
			scripts[i].errors.push(error);
		}
	} else if (callback) {
		callback();
	}
};
